import { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
  className?: string;
}

export default function Container({ children, className = '' }: ContainerProps) {
  return <div className={`mx-auto py-6 md:py-10 w-full px-4 md:px-20 2xl:px-36 ${className}`}>{children}</div>;
}
